export default __webpack_public_path__ + "static/generationen-clip-1-6354d1afa51e38cae6878857333f0e4e.mp4";